import { IComparisonNotification } from '../../types/offersComparion';
import { IApplicationState } from '../../types/redux';

export function selectOffersComparisonNotification(state: IApplicationState): IComparisonNotification | null {
  return state.comparisonNotification;
}
